export const PROPERTIES_PANEL_SECTION_ORDER = [
  'object',
  'type',
  'photo',
  'layout',
  'effects',
] as const
